var AuthenticationDriverMevodoAccounts = /** @class */ (function () {
    function AuthenticationDriverMevodoAccounts() {
    }
    AuthenticationDriverMevodoAccounts.prototype.buildAccountsBaseUri = function (alternativeHost) {
        if (alternativeHost) {
            return alternativeHost + '/protocols/oauth2';
        }
        else {
            var prefix = window.location.host.indexOf('localhost') === -1 ? '/accounts' : '';
            var stsHost = window.location.origin.indexOf('localhost') === -1 ? window.location.host : window.location.hostname + ':5083';
            // build the login uri            
            return window.location.protocol + '//' + stsHost + prefix + '/protocols/oauth2';
        }
    };
    AuthenticationDriverMevodoAccounts.prototype.triggerAuthenticationFlow = function (clientId, scope, alternativeHost) {
        // define the environmet                        
        var redirectUri = window.location.origin + process.env.PUBLIC_URL;
        // build the login uri            
        var loginUri = this.buildAccountsBaseUri(alternativeHost) + '/authorize?client_id=' + encodeURIComponent(clientId) + '&redirect_uri=' + encodeURIComponent(redirectUri) + '&response_type=token&response_mode=query&scope=' + encodeURIComponent(scope);
        // store the redirect uri for later use
        sessionStorage.setItem('mv.final.target', window.location.href);
        // naviagte await            
        window.location.replace(loginUri);
    };
    AuthenticationDriverMevodoAccounts.prototype.triggerLogoutFlow = function (alternativeHost) {
        var logOutUri = this.buildAccountsBaseUri(alternativeHost) + '/goodbye';
        var returnUrl = window.location.origin + process.env.PUBLIC_URL;
        logOutUri += '?redirect_uri=' + encodeURIComponent(returnUrl);
        window.location.replace(logOutUri);
    };
    return AuthenticationDriverMevodoAccounts;
}());
export { AuthenticationDriverMevodoAccounts };
